import React, { useContext, useState } from "react"
import {
	KopyBasicItem,
	KopyPlusItem,
	KopyProtectItem,
} from "../subscription/BillingItems.jsx"
import { useRemoveItemFromSubscription } from "../../hooks/usePaddleHooks.js"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import { Modal } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { Button } from "@shopify/polaris"
import { Spinner } from "../Spinner.jsx"

const itemNameMap = {
	basic: "Kopy Basic",
	plus: "Kopy Plus",
	protect: "Kopy Protect",
}

export const SubscriptionItems = () => {
	const { state } = useContext(GlobalStateContext)
	const { t } = useTranslation()
	const removeItemFromSubscription = useRemoveItemFromSubscription()

	const [
		showRemoveItemFromSubscriptionModal,
		setShowRemoveItemFromSubscriptionModal,
	] = useState(false)
	const [itemToRemove, setItemToRemove] = useState(null)
	const [removingItemLoading, setRemovingItemLoading] = useState(false)

	const openModal = (item) => {
		setItemToRemove(item)
		setShowRemoveItemFromSubscriptionModal(true)
	}

	const onCloseModal = () => {
		setItemToRemove(null)
		setShowRemoveItemFromSubscriptionModal(false)
	}

	const _removeItemFromSubscription = async (item) => {
		setRemovingItemLoading(true)
		await removeItemFromSubscription([item])
		setRemovingItemLoading(false)
		window.location.reload()
	}

	const showRemoveItemButtons =
		[
			state.hasValidKopyBasicSubscription,
			state.hasValidKopyPlusSubscription,
			state.hasValidKopyProtectSubscription,
		].filter((item) => item === true).length >= 2

	return (
		<div
			style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
		>
			{state.hasValidKopyBasicSubscription && (
				<KopyBasicItem
					displayRemove={showRemoveItemButtons}
					onRemove={() => openModal("basic")}
				/>
			)}
			{state.hasValidKopyPlusSubscription && (
				<KopyPlusItem
					displayRemove={showRemoveItemButtons}
					onRemove={() => openModal("plus")}
				/>
			)}
			{state.hasValidKopyProtectSubscription && (
				<KopyProtectItem
					displayRemove={showRemoveItemButtons}
					onRemove={() => openModal("protect")}
				/>
			)}

			<Modal
				title={
					<div style={{ fontSize: "1.3rem", fontWeight: "600" }}>
						{t("account.confirm_changes")}
					</div>
				}
				centered
				radius="md"
				opened={showRemoveItemFromSubscriptionModal}
				onClose={onCloseModal}
			>
				<p style={{ marginTop: "1rem" }}>
					{t(
						"account.do_you_wish_to_remove_the_following_from_your_subscription",
					)}
				</p>

				<p style={{ marginTop: "1rem" }}>
					<b>{itemNameMap?.[itemToRemove] || ""}</b>
				</p>

				<p style={{ marginTop: "1rem" }}>
					{t(
						"account.you_will_instantly_lose_access_to_all_your_benefits_that_it_provides",
					)}
				</p>

				<div style={{ marginTop: "2rem" }}>
					<Button
						fullWidth
						destructive
						onClick={() =>
							_removeItemFromSubscription(itemToRemove)
						}
					>
						{removingItemLoading ? (
							<Spinner />
						) : (
							t("common.confirm")
						)}
					</Button>
				</div>
			</Modal>
		</div>
	)
}
